import { Observable } from 'rxjs';

import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import * as GridActions from '../state/grid/grid.actions';
import { IGridState } from '../state/grid/grid.state';
import { GRID_CONFIG, IGridConfig } from './grid-center.token';

@Injectable()
export class GridCenterService {
  skipRowsNumber$: Observable<number | undefined>;
  searchCriteria$: Observable<any | undefined>;
  rowsPerPage$: Observable<number | undefined>;
  identifier$: Observable<string | undefined>;

  constructor(
    @Inject(GRID_CONFIG) private gridConfig: IGridConfig,
    public store: Store<IGridState>
  ) {
    this.skipRowsNumber$ = store.select(
      (state) => state.gridState[gridConfig.gridName].skipRows
    );
    this.searchCriteria$ = store.select(
      (state) => state.gridState[gridConfig.gridName].searchCriteria
    );
    this.rowsPerPage$ = store.select(
      (state) => state.gridState[gridConfig.gridName].searchCriteria.rowsPerPage
    );
    this.identifier$ = store.select(
      (state) => state.gridState[gridConfig.gridName].identifier
    );

    store
      .select((state) => state.gridState[gridConfig.gridName])
      .subscribe((gridState) => {
        if (!gridState) {
          this.setSkipRows(0);
          this.setSearchCriteria(gridConfig.initialData);
        }
      });
  }

  setSkipRows(skip: number) {
    this.store.dispatch(
      GridActions.setSkipRows({
        skipRows: skip,
        gridName: this.gridConfig.gridName,
      })
    );
  }

  setIdentifier(identifier: string | number) {
    this.store.dispatch(
      GridActions.setIdentifier({
        identifier: identifier,
        gridName: this.gridConfig.gridName,
      })
    );
  }

  setSearchCriteria<T>(searchCriteria: T) {
    this.store.dispatch(
      GridActions.setSearchCriteria({
        searchCriteria,
        gridName: this.gridConfig.gridName,
      })
    );
  }

  setPageNumber(pageNumber: number) {
    this.store.dispatch(
      GridActions.setPageNumber({
        pageNumber,
        gridName: this.gridConfig.gridName,
      })
    );
  }

  setRowsPerPage(rowsPerPage: number) {
    this.store.dispatch(
      GridActions.setRowsPerPage({
        rowsPerPage,
        gridName: this.gridConfig.gridName,
      })
    );
  }

  resetIdentifier() {
    this.store.dispatch(GridActions.resetIdentifier({gridName: this.gridConfig.gridName}));
  }
}
